import { useNavigate, useParams } from 'react-router-dom';

import React, { useEffect, useState, useCallback } from 'react';
import styled, { keyframes } from 'styled-components';
// import QrReader from 'react-web-qr-reader';
import { QrReader } from 'react-qr-reader';
import { useGetInoutSel, useSetInoutHist } from '../../../../interface/inout';
import NaviText from '../../../backoffice/common/NaviText';
import { Row } from '../../../../styles/common';
import { Collapse, Drawer, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import Button from '../../../common/Button';
import useSound from 'use-sound';
import FoldingBar from '../../../common/FoldingBar';
import moment from 'moment';
import { useGetItemByTno } from '../../../../interface/item';

const MainWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const QRWrapper = styled.div`
    width: calc(100% - 8rem);
    height: auto;
    section div {
        border: 0 !important;
        box-shadow: none !important;
    }

    video {
        border-radius: 25%;
    }

    border-radius: 25%;
`;

const InspectItemInfo = () => {

    // const delay = 500;
    const delay = 100;

    const navigate = useNavigate();
    const param = useParams();

    const [result, setResult] = useState('');
    const [msg, setMsg] = useState('');
    const [sno, setSno] = useState();
    const [folding, setFolidng] = useState(false);

    const { data: inoutList} = useGetInoutSel();
    const { data: itemInfo, refetch: itemRefetch,remove} = useGetItemByTno(result);
    const { mutate } = useSetInoutHist();

    const [normal] = useSound('/sound/normal.mp3');

    // const [deviceId, setDeviceId] = useState(null);

    useEffect(()=>{
        if(result && result.tid){
            normal();
            setSno();
            itemRefetch();
        }
    },[result])

    useEffect(()=>{
            if(itemInfo && itemInfo.length===0) {
                setMsg('등록되어있지 않은 자산입니다.')
            }else if(itemInfo && itemInfo.length>0){
                setSno(itemInfo[0].sno)
                const target = inoutList.find((item)=>item.sno === itemInfo[0].sno)
                setMsg('')
            }
    },[itemInfo])

    // const handleDevices = useCallback(
    //     mediaDevices => {
    //         const frontCamera = mediaDevices.find(media => /front|user|selfie/i.test(media.label));
    //         if (frontCamera) {
    //             setDeviceId(frontCamera.deviceId);
    //         }
    //     }, [setDeviceId]
    // );

    // useEffect(()=>{
    //     navigator.mediaDevices.enumerateDevices().then(handleDevices);
    //   }, [handleDevices]);

    const handleScan = (sresult) => {
        // if (sresult && sresult.data) {
        //     if(sresult.data.indexOf('TAMS')>-1){
        //         const target = sresult.data.replace('TAMS','')
        //         target !== result.tid && setResult({tid:target});
        //         // setResult({tno:sresult.data});
        //     }else{
        //         setMsg('잘못된 QR CODE입니다.')
        //     }
        // }

        //20251107
        if (sresult && sresult?.text) {
            if(sresult?.text.indexOf('TAMS')>-1){
                const target = sresult?.text.replace('TAMS','');
                target !== result?.tid && setResult({tid:target});
            }else{
                setMsg('잘못된 QR CODE입니다.')
            }
        }
    };

    const handleError = (error) => {
        console.log(error);
    };

    const handleUpdate = useCallback((param) => {
        mutate({mode:'PUT',...param, sno:sno})
    },[mutate]);

    return (
        <React.Fragment>
            <div style={{padding: '0rem 1rem',display:'flex',alignItems:'center',justifyContent:'flex-start',gap:'8px'}}>
                <img src={`/images/ic_back_arrow.svg`} style={{width:'1.15rem'}} onClick={()=>navigate(-1)}/>
                <NaviText target={[{text:'자산확인'}]} />
            </div>
            <MainWrap>
                <QRWrapper>
                    <img src={`/images/back_qr_radar.svg`} style={{ display: 'block', position: 'absolute', width: 'calc(100% - 8rem)',zIndex:1, opacity:'0.8'}} alt='' />
                    <QrReader
                        // delay={delay}
                        // // facingMode={'environment'}
                        // // deviceId={deviceId}
                        // constraints={{ facingMode: 'environment' }}
                        // onError={handleError}
                        // onScan={handleScan}

                        //20251107
                        scanDelay={delay}
                        onResult={(result, error) => {
                            if (result) handleScan(result);
                            if (error) handleError(error);
                        }}       

                        constraints={{ facingMode: 'environment', advanced: [{ zoom: 3.0 }]  }}
                        videoStyle={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        }}            
                    />
                </QRWrapper>
                {msg && msg}
                {(itemInfo && itemInfo.length > 0) &&
                    <React.Fragment>
                        <Row style={{width:'100%',padding:'1rem 1rem 0rem 1rem', display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                            <TextField
                                id='tno' 
                                label='자산번호' 
                                size='small' 
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                disabled
                                value={itemInfo && itemInfo[0].tno}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                id='lot_no' 
                                label='표기번호' 
                                size='small' 
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                disabled
                                value={itemInfo && itemInfo[0].lot_no}
                                // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField
                                label='구분'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].pcat_nm}
                            />
                            <TextField
                                label='분류'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].cat_nm}
                            />
                            <TextField 
                                    id='model_nm' 
                                    label='모델명' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].model_nm}
                                    // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                                />
                            <TextField
                                label='상태'
                                InputProps={{
                                    readOnly: true,
                                }}
                                InputLabelProps={{shrink:true}} 
                                size='small'
                                disabled
                                // placeholder='분류'
                                value={itemInfo && itemInfo[0].status_nm}
                            />
                        </Row>
                        <FoldingBar onClick={setFolidng}/>
                        <Collapse in={folding}>
                            <Row style={{width:'100%',padding:'0.5rem 1rem', display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                                <TextField 
                                    id='model_sub' 
                                    label='모델유형' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].model_sub}
                                />
                                <TextField 
                                    id='location' 
                                    label='위치' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].location}
                                />
                                <TextField 
                                    id='serial_no' 
                                    label='시리얼넘버' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].serial_no}
                                />
                                <TextField 
                                    id='maf_date'
                                    label='제조일자' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && moment(itemInfo.maf_date).format('YYYY-MM-DD')}
                                />
                                <TextField 
                                    id='pur_date'
                                    label='구매일자' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && moment(itemInfo.pur_date).format('YYYY-MM-DD')}
                                />
                                <TextField 
                                    id='pur_tpnm'
                                    label='구매구분' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].pur_tpnm}
                                />
                                <TextField 
                                    id='pur_price'
                                    label='구매가격' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].pur_price}
                                />
                                <TextField 
                                    id='uid1'
                                    label='책임자' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].uid1_nm}
                                />
                                <TextField 
                                    id='ui2'
                                    label='부책임자' 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].uid2_nm}
                                />
                            </Row>
                            <Row style={{width:'100%',padding:'0.5rem 1rem'}}>
                                <TextField 
                                    id='spec' 
                                    label='사양' 
                                    fullWidth 
                                    multiline 
                                    rows={2} 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].spec}
                                />
                            </Row>
                            <Row style={{width:'100%',padding:'0.5rem 1rem'}}>
                                <TextField 
                                    id='descr1' 
                                    label='비고1' 
                                    fullWidth 
                                    multiline 
                                    rows={2} 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].descr1}
                                />
                            </Row>
                            <Row style={{width:'100%',padding:'0.5rem 1rem 1rem 1rem'}}>
                                <TextField 
                                    id='descr2' 
                                    label='비고2' 
                                    fullWidth 
                                    multiline 
                                    rows={2} 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].descr2}
                                />
                            </Row>
                            <Row style={{width:'100%',padding:'0.5rem 1rem 1rem 1rem'}}>
                                <TextField 
                                    id='io_descr' 
                                    label='반출입 관리 메모' 
                                    fullWidth 
                                    multiline 
                                    rows={2} 
                                    size='small' 
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    InputLabelProps={{shrink:true}} 
                                    disabled
                                    value={itemInfo && itemInfo[0].io_descr}
                                />
                            </Row>
                        </Collapse>
                    </React.Fragment>
                }
            </MainWrap>
        </React.Fragment>
    )

}

export default InspectItemInfo;